import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import api from '../../../services/api';
import { useEffect, useState } from 'react';
import Spinner from '../../../rxlib/components/spinner';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApiError, FormExclusao } from '../../../services/tipos';
import { Exclusao } from '../../../rxlib/components/layout/exclusao';

interface ProdutoLicenciadaExclusaoProps {
    show: boolean;
    onHide: () => void;
    idProdutoLicenciada: string;
    onExcluir: (valor: boolean) => void;
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
}

function ProdutoLicenciadaExclusao(props: ProdutoLicenciadaExclusaoProps) {
    const [produto, setProduto] = useState<string>('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const [carregandoProdutoLicenciada, setCarregandoProdutoLicenciada] = useState<boolean>(false);

    const { handleSubmit } = useForm<FormExclusao>();

    useEffect(() => {
        if (props.show) {
            setCarregandoProdutoLicenciada(true);
            api.get(`/OData/ProdutoLicenciada?$filter=id eq ${props.idProdutoLicenciada}&$expand=produto`)
                .then(response => {
                    setProduto(response.data.value[0].Produto.Nome);
                    setCarregandoProdutoLicenciada(false);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregandoProdutoLicenciada(false);
                    props.tratarErro(error, 'Não foi possível realizar a consulta: ');
                });
        }
    }, [props]);

    const onSubmit: SubmitHandler<FormExclusao> = data => {
        setCarregando(true);
        api.delete(`/ProdutoLicenciada/${props.idProdutoLicenciada}`, data)
            .then(response => {
                informarSucesso();
            }).catch((error: AxiosError<ApiError>) => {
                setCarregando(false);
                props.tratarErro(error, 'Não foi possível excluir o produto da licenciada: ');
            });
    }

    function informarSucesso() {
        props.onHide();
        props.onExcluir(true);
        setCarregando(false);
    }

    return (
        <Modal show={props.show} onHide={props.onHide} dialogClassName='rxlib-modal-exclusao' centered>
            <Modal.Body className='rxlib-modal-exclusao-body'>
                {
                    carregandoProdutoLicenciada
                        ? <Spinner
                            classStyle='rxlib-spinner' />
                        : <Exclusao
                            carregando={carregando}
                            onCancelar={props.onHide}
                            onSubmit={handleSubmit(onSubmit)}
                            titulo={`Deseja realmente excluir o produto ${produto}?`} />
                }
            </Modal.Body>
        </Modal>
    );
}

export default ProdutoLicenciadaExclusao;